<!--宝记周期界面-->
<template>
  <div>
    <van-calendar
        :show-title="false"
        :poppable="false"
        :show-confirm="false"
        :style="{ height: '500px' }"
        :min-date="minDate"
        first-day-of-week="1"
        type="single"
        :formatter="formatter"
        confirm-text="完成"
        :color="recColor"
        @select="selectDate"
    >
      <template slot="top-info" slot-scope="day">
        <van-icon :name="iconType(day)" v-show="showFlag(day)"/>
      </template>
      <template slot="bottom-info" slot-scope="day">
        <van-icon :name="iconBottomType(day)" v-show="showBottomFlag(day)"/>
      </template>
    </van-calendar>
    <van-row type="flex" justify="end" style="margin-top: 30px">
      <van-col span="4">
        <van-icon name="play-circle-o" size="25" color="#4fc08d" @click="confirmDate"/>
      </van-col>
      <van-col span="4">
        <van-icon name="pause-circle-o" size="25" color="#323233" @click="pauseDate"/>
      </van-col>
      <van-col span="4">
        <van-icon name="close" size="25" color="#ee0a24" @click="closeDate"/>
      </van-col>
    </van-row>

<!--    <van-button style="margin-top: 10px;" type="primary" size="small"-->
<!--                block round :color="recColor" :loading="isLoading"-->
<!--                loading-text="记录中..."-->
<!--                @click="confirmDate">记录</van-button>-->
  </div>
</template>

<script>
import * as DateUtil from "../../common/utils/dateUtil";
import * as MyApi from "@/api/URLApiAddr";
import * as BusiConsts from '@/common/BusiConsts.js'
import store from '@/store'
import * as types from '@/common/types/mutation.js'
export default {

  name: "BaoRecord.vue",
  props:{
    recColor: String,
    recType: Number
  },
  data() {
    return {
      minDate: DateUtil.dayOfDateNum(-60),
      list:[{id:1,name:"pause-circle-o"}],
      isShow: false,
      localRecType : this.recType,
      selectDay: '',

    }
  },
  methods: {
    formatter(day) {
      const thisDate = this.getCurrentDate(day);
      const baoRecords = store.state.busi.baoRecords;
      let tmpList = baoRecords[this.recType];
      for(let i = 0 ; i < tmpList.length; i++){
        let res = tmpList[i];
        if (thisDate == res.recDate) {
          //console.log(thisDate)
          if (BusiConsts.BAO_REC_FLAG_START == res.recFlag) {
            day.type = "start";
          } else if (BusiConsts.BAO_REC_FLAG_END == res.recFlag) {
            day.type = "end";
          } else if(BusiConsts.BAO_REC_FLAG_MIDDLE == res.recFlag){
            day.type = "middle";
          }

        }

      }
      //处理今日数据,如果没有选择当天则不进行颜色标注
      let recDate = DateUtil.formatDate(new Date,'yyyy-MM-dd')
      if(recDate == thisDate){
        day.text = '今日';
      }
      return day;
    },
    showFlag(day){
      if(day.type == 'placeholder'){
        return ;
      }

      const thisDate = this.getCurrentDate(day);
      const baoRecords = store.state.busi.baoRecords;
      let tmpList = baoRecords[this.recType];
      for(let i = 0 ; i < tmpList.length; i++){
        let res = tmpList[i];
        //let split = res.split("-");
        if (thisDate == res.recDate) {
          return true;
        }

      }
      return false;
    },
    iconType(day){
      if(day.type == 'placeholder'){
        return ;
      }
      const thisDate = this.getCurrentDate(day);
      const baoRecords = store.state.busi.baoRecords;
      let tmpList = baoRecords[this.recType];
      for(let i = 0 ; i < tmpList.length; i++){
        let res = tmpList[i];
        //let split = res.split("-");
        if (thisDate == res.recDate) {
          //console.log("tag:"+thisDate)
          if (BusiConsts.BAO_REC_FLAG_START == res.recFlag) {
            return "play-circle-o";
          } else if (BusiConsts.BAO_REC_FLAG_END == res.recFlag) {
            return "pause-circle-o";
          } else if(BusiConsts.BAO_REC_FLAG_MIDDLE == res.recFlag){
            return "";
          }

        }

      }
      return "";
    },
    iconBottomType(day){
      if(day.type == 'placeholder'){
        return ;
      }
      const thisDate = this.getCurrentDate(day);
      if(this.selectDay == thisDate){
        return "circle";
      }
      return "";
    },
    showBottomFlag(day){
      if(day.type == 'placeholder'){
        return ;
      }
      const thisDate = this.getCurrentDate(day);
      if(this.selectDay == thisDate){
        return true;
      }
      return false;
    },
    selectDate(date){
      let recDate = DateUtil.formatDate(date,'yyyy-MM-dd')
      let today = DateUtil.formatDate(new Date,'yyyy-MM-dd')
      this.selectDay = recDate
      if(recDate == today){
        this.selectToday = true;
      }else{
        this.selectToday = false;
      }

    },
    confirmDate(){
      let user = store.state.sys.user
      //params.userId = user.userId
      let recDate = this.selectDay

      let params = {userId:user.userId}
      params.recDate = recDate
      params.recType = this.recType
      params.recFlag = BusiConsts.BAO_REC_FLAG_START

      this.$axios.post(MyApi.SAVE_CYCLE_BAO_REC,params/*,options*/)
          // 请求成功后
          .then((resp) => {
            //let data = response.data;
            if('200' == resp.code){
              store.commit(types.BUSI+types.BAO_RECORDS_TYPE,resp.data);
              this.$toast.success(resp.msg);
            }
          })
          .catch((err) => {
            this.$toast.fail("请求异常,请稍后再试");
          })

    },
    pauseDate(){
      let user = store.state.sys.user
      //params.userId = user.userId
      let recDate = this.selectDay

      let params = {userId:user.userId}
      params.recDate = recDate
      params.recType = this.recType
      params.recFlag = BusiConsts.BAO_REC_FLAG_END

      this.$axios.post(MyApi.SAVE_CYCLE_BAO_REC,params/*,options*/)
          // 请求成功后
          .then((resp) => {
            //let data = response.data;
            if('200' == resp.code){
              store.commit(types.BUSI+types.BAO_RECORDS_TYPE,resp.data);
              this.$toast.success(resp.msg);
            }
          })
          .catch((err) => {
            this.$toast.fail("请求异常,请稍后再试");
          })

    },
    closeDate(){
      let user = store.state.sys.user
      //params.userId = user.userId
      let recDate = this.selectDay

      let params = {userId:user.userId}
      params.recDate = recDate
      params.recType = this.recType

      this.$axios.post(MyApi.DEL_CYCLE_BAO_REC,params/*,options*/)
          // 请求成功后
          .then((resp) => {
            //let data = response.data;
            if('200' == resp.code){
              store.commit(types.BUSI+types.BAO_RECORDS_TYPE,resp.data);
              this.$toast.success(resp.msg);
            }
          })
          .catch((err) => {
            this.$toast.fail("请求异常,请稍后再试");
          })

    },
    getCurrentDate(day){
      const fullYear = day.date.getFullYear();
      let month = day.date.getMonth() + 1;
      if(month < 10){
        month = "0"+month;
      }
      let date = day.date.getDate();
      if(date < 10){
        date = "0" + date;
      }
      const thisDate = fullYear + "-" +month + "-" +date;
      return thisDate;
    }
  }
}
</script>

<style scoped>

</style>